import { render, staticRenderFns } from "./DehorningType.vue?vue&type=template&id=b186a0ce&scoped=true&"
import script from "./DehorningType.vue?vue&type=script&lang=js&"
export * from "./DehorningType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b186a0ce",
  null
  
)

export default component.exports